import * as React from 'react'

import Docxtemplater from 'docxtemplater'

import ImageModule from 'docxtemplater-image-module-free'
import Pizzip from 'pizzip'

// import { renderAsync } from 'docx-preview'

import { Box, Card, Grid } from '@mui/material'
import { styled } from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'

import { DropzoneWrapper } from '@/views/samples/create-sample/DropzoneStyle'
import FileUploaderMultiple from '@/views/forms/file-uploader/FileUploaderMultiple'
import EditorControlled from '@/@core/components/draft/EditorControlled'
import { EditorWrapper } from '@/@core/components/draft/react-draft-wysiwyg-style'
import FileSaver from 'file-saver'
import {
  calculateAndFormat,
  chromosomeRegion,
  demo,
  deserialize,
  formatDate,
  formatAminoAcidMutation,
  unique,
  formatSpecialInheritance,
  parseMutation,
  changeAcmgText,
  switchACMG
} from '@/@core/utils/utils'
import PasteHtmlExample from '@/@core/components/braft/react-slate'
import { useTranslation } from 'react-i18next'
import {
  judgeAcmg,
  judgeAcmgGrade,
  judgeEvidenceDetails,
  judgeVariantType
} from '@/@core/layouts/utils'
import { judgeStrength } from '@/views/analyze/ACMG'
import { ACMG_evidences_zh } from '../CurrentRepoet'
import i18n from '@/configs/i18n'
import { useMutation } from 'react-query'
import { localUpload, UploadOSSFIle } from '@/@core/services/app.service'
import { AxiosRequestConfig } from 'axios'

interface Props {
  template: string
  report: any
  reportValue: any
  reportsVariants: any[]
  reportsVariantsType: any
  samples: any[]
  affected_child_clinicalInformation: any
  props: any
  sanger: any[]
  chromosomeData: any[]
  userAcmgData: any[]
  detectionMTVariationList: any[]
  detectionTumorVariationList: any[]
  detectionRawDataVariationList: any[]
  strRang: any[]
  currentRohList: any[]
  affected_child_patientName: string
  signature: string
  signature2: string
  signature3: string
  signature4: string
  isACMGSF: boolean
  isRoh: boolean
}

const rohOMIM = [
  {
    type: '父源性 UPD6',
    syndrome: '新生儿短暂性糖尿病',
    omim: '#601410',
    phenotype: '新生儿短暂性糖尿病，宫内生长受限',
    chrom: '6'
  },
  {
    type: '母源性 UPD(7)',
    syndrome: 'Silver-Russell 综合征',
    omim: '#180860',
    phenotype:
      '宫内生长受限，出生后发育迟滞，大头畸形，三角形脸，肢体、面部不对称',
    chrom: '7'
  },
  {
    type: '母源性 UPD(11)',
    syndrome: 'Silver-Russell 综合征',
    omim: '#180860',
    phenotype:
      '宫内生长受限，出生后发育迟滞，大头畸形，三角形脸，肢体、面部不对称',
    chrom: '11'
  },
  {
    type: '父源性 UPD(11)',
    syndrome: 'Beckwith-Wiedemann 综合征',
    omim: '#130650',
    phenotype:
      '产前产后过度生长，器官增大，舌大，脐膨出，新生儿低血糖，肿瘤风险增加',
    chrom: '11'
  },
  {
    type: '父源性 UPD(14)',
    syndrome: 'Kagami-Ogata 综合征',
    omim: '#608149',
    phenotype: '羊水过多，腹壁缺损，骨骼异常，狭窄的钟形胸廓合并前肋骨弓',
    chrom: '14'
  },
  {
    type: '母源性 UPD(14)',
    syndrome: 'Temple 综合征',
    omim: '#616222',
    phenotype:
      '宫内生长受限，出生后发育迟滞，出生时低体重、肌张力低下、运动功能落后、早期喂养困难、青春期提早、青春期后的躯干型肥胖、成年身高显著偏低，小手小脚',
    chrom: '14'
  },
  {
    type: '父源性 UPD(15)',
    syndrome: 'Angelman 综合征',
    omim: '#105830',
    phenotype: '小头，共济失调，癫痫，智力发育迟滞，语言能力差，微笑面容',
    chrom: '15'
  },
  {
    type: '母源性 UPD(15)',
    syndrome: 'Prader-Willi 综合征',
    omim: '#176270',
    phenotype:
      '新生儿肌张力低下，婴儿期喂养困难，儿童期后肥胖，生长发育迟缓，智力迟钝，行为问题',
    chrom: '15'
  },
  {
    type: '父源性 UPD(20)',
    syndrome: '假性甲状旁腺',
    omim: '#139320',
    phenotype: '假性甲状旁腺功能减退功能减退症',
    chrom: '20'
  },
  {
    type: '母源性 UPD(20)',
    syndrome: 'Mulchandani-Bhoj-Conlin 综合征',
    omim: '#617352',
    phenotype: '宫内生长受限，出生后发育迟滞',
    chrom: '20'
  }
]
const inheritancePatterns = [
  {
    abbreviation: 'AD',

    fullName: '常染色体显性',

    category: '常染色体显性'
  },

  {
    abbreviation: 'AR',

    fullName: '常染色体隐性',

    category: '常染色体隐性'
  },

  {
    abbreviation: 'PD',

    fullName: '伪常染色体显性',

    category: '伪常染色体显性'
  },

  {
    abbreviation: 'PR',

    fullName: '假常染色体隐性',

    category: '假常染色体隐性'
  },

  {
    abbreviation: 'DD',

    fullName: '双基因显性',

    category: '双基因显性'
  },

  {
    abbreviation: 'DR',

    fullName: '双基因隐性',

    category: '双基因隐性'
  },

  {
    abbreviation: 'IC',

    fullName: '孤立病例',

    category: '孤立病例'
  },

  {
    abbreviation: 'ICB',

    fullName: '染色体不平衡',

    category: '染色体不平衡'
  },

  {
    abbreviation: 'Mi',

    fullName: '线粒体',

    category: '线粒体'
  },

  {
    abbreviation: 'Mu',

    fullName: '多因素',

    category: '多因素'
  },

  {
    abbreviation: 'SMO',

    fullName: '索马里嵌合体',

    category: '索马里嵌合体'
  },

  {
    abbreviation: 'SMU',

    fullName: '体细胞突变',

    category: '体细胞突变'
  },

  {
    abbreviation: 'XL',

    fullName: 'X连锁',

    category: 'X连锁'
  },

  {
    abbreviation: 'XLD',

    fullName: 'X连锁显性',

    category: 'X连锁显性'
  },

  {
    abbreviation: 'XLR',

    fullName: 'X连锁隐性遗传',

    category: 'X连锁隐性'
  },

  {
    abbreviation: 'YL',

    fullName: 'Y连锁遗传',

    category: 'Y连锁'
  }
]

const WordReport = React.forwardRef((props: Props, ref) => {
  // ** State
  const { t } = useTranslation()

  demo()
  const [files, setFiles] = React.useState<File[]>([])
  const dom = React.useRef<HTMLElement>()
  const edit = React.useRef<any>()
  const [openNewReport, setOpenNewReport] = React.useState(false)
  const [data, setData] = React.useState<any>()
  const [out, setOut] = React.useState<any>()
  const [html, setHtml] = React.useState([])
  const [url, setUrl] = React.useState('')

  const handleClose = () => {
    setOpenNewReport(false)

    setOut(undefined)
  }

  const formatArray = (arr: any[]) => {
    if (arr.length === 0) return '[]'

    if (arr.length === 1) return `[${arr[0]}]`

    // 检查连续性

    const isContinuous = arr.every(
      (val, idx) => idx === arr.length - 1 || val + 1 === arr[idx + 1]
    )

    return `[${
      isContinuous ? `${arr[0]}-${arr[arr.length - 1]}` : arr.join(',')
    }]`
  }

  // 辅助函数：格式化样本信息
  const formatSampleInfo = (sample: any) => {
    const fastQc = sample.fastQc ?? {}
    const metricsData = fastQc.metricsData ?? {}
    const rawReads = metricsData.rawReads ?? '-'
    const totalBases =
      rawReads === '-'
        ? '-'
        : calculateAndFormat(`${metricsData.rawReads}`, 150)
    const readsMappedPercent = metricsData.readsMappedPercent ?? '-'
    const pctData = (fastQc.barChartData ?? []) as any[]
    const x1 = `${
      pctData.find((i) => i.name === '1x')?.value?.toFixed(2) ?? '-'
    }%`
    const x10 = `${
      pctData.find((i) => i.name === '10x')?.value?.toFixed(2) ?? '-'
    }%`
    const x20 = `${
      pctData.find((i) => i.name === '20x')?.value?.toFixed(2) ?? '-'
    }%`
    const x30 = `${
      pctData.find((i) => i.name === '30x')?.value?.toFixed(2) ?? '-'
    }%`
    const seqtk_q30 =
      metricsData.seqtk_q30 && Array.isArray(metricsData.seqtk_q30)
        ? metricsData.seqtk_q30
        : []

    const q30 = `${
      seqtk_q30[0]?.average_Q30
        ? seqtk_q30[0]?.average_Q30
        : seqtk_q30[0]?.avg_q30
        ? seqtk_q30[0]?.avg_q30
        : '-'
    }%`

    return {
      patientName: sample.patient?.patientName,
      sampleName: sample.sample?.name,
      gender: t(sample.patient?.gender ?? '-'),
      caseNumber: sample.patient?.caseNumber ?? '-',
      phenotype: sample.patient?.phenotype ?? '-',
      resultsIn: sample.patient?.resultsIn ?? '-',
      departmentName: sample.patient?.departmentName ?? '-',
      physicianName: sample.patient?.physicianName ?? '-',
      dateOfBirth: formatDate(sample.patient?.dateOfBirth, 'YYYY-MM-DD') ?? '-',
      birthDay: sample.patient?.dateOfBirth
        ? `${Math.max(
            0,
            Math.floor(
              (new Date().valueOf() -
                new Date(sample.patient?.dateOfBirth).valueOf()) /
                3.15576e10
            )
          )}岁`
        : '-',
      fileSize:
        rawReads && rawReads !== '-'
          ? `${(rawReads / 1024 / 1024 / 1024).toFixed(2) + 'Gb'}`
          : sample.sample?.fileSize
          ? sample.sample?.fileSize > 1000
            ? `${(sample.sample?.fileSize / 1024)?.toFixed(2)}G`
            : `${sample.sample?.fileSize}MB`
          : '-',
      sampleType: t(sample.sample?.vcfType ?? '-'),
      sampleTypes: t(sample.patient?.sampleType ?? '-'),
      collectDate: formatDate(sample.patient?.arrivalDate, 'YYYY-MM-DD') ?? '-',
      arrivalDate: formatDate(sample.patient?.receiveDate, 'YYYY-MM-DD') ?? '-',
      infirmaryName: sample.patient?.infirmaryName ?? '-',
      rawReads: rawReads ? `${readsMappedPercent}` : `-`,
      totalBases: totalBases,
      avgReadDepth: `${sample.sample?.avgReadDepth?.toFixed(2) ?? '-'}`,
      meanCoverage: `${metricsData?.meanCoverage ?? '-'}`,
      x1,
      x10,
      x20,
      x30,
      q30
    }
  }

  // 辅助函数：处理变异的zygosity信息
  const processZygosity = (row: any, isShowName?: boolean) => {
    return props.samples
      .map((item) => {
        let allele_frequency = row.allele_frequency ?? row.allele_balance
        const cn = row.cn ?? row.CN
        const samples_info = row.samples_info ?? []

        const temp = samples_info.find(
          (i: any) => i.sample_id === item.sample.id
        )
        if (temp && temp.allele_frequency) {
          allele_frequency = temp.allele_frequency
        }

        if (item.sample.type === 'mother' && row.mom_allele_frequency) {
          allele_frequency = row.mom_allele_frequency
        } else if (item.sample.type === 'father' && row.dad_allele_frequency) {
          allele_frequency = row.dad_allele_frequency
        }

        if (isShowName)
          return `${
            item.patient?.patientName
              ? `${item.patient?.patientName}:`
              : item.sample.type
              ? `${t(item.sample.type)}:`
              : ''
          }${
            allele_frequency && allele_frequency !== '.'
              ? allele_frequency < 0.85
                ? `${t('Heterozygote')}(${allele_frequency.toFixed(2)})`
                : `${t('Homozygote')}(${allele_frequency.toFixed(2)})`
              : cn
              ? `拷贝数：${cn}`
              : '无'
          }`
        else
          return `${
            allele_frequency && allele_frequency !== '.'
              ? allele_frequency < 0.85
                ? `${t('Heterozygote')}(${allele_frequency.toFixed(2)})`
                : `${t('Homozygote')}(${allele_frequency.toFixed(2)})`
              : cn
              ? `拷贝数：${cn}`
              : '无'
          }`
      })
      .join('\n')
  }

  React.useEffect(() => {
    const enmptyVariant = [
      {
        gene: '-',
        chrompos: '-',
        transcript: '-',
        feature: '-',
        nuc_change: '-',
        c_nomen: '-',
        Cnomen: '-',
        hgvsc: '-',
        p_nomen: '-',
        hgvsp: '-',
        chrom: '-',
        pos: '-',
        REF: '-',
        ref: '-',
        ALT: '-',
        alt: '-',
        Mpos: '-',
        var_location: '-',
        coding_effect: '-',
        coding_effect_zh: '-',
        exon: '-',
        Exon: '-',
        acmgClass: '-',
        zygosity: '-',
        OMIM_zh: '-',
        mtPos: '-',
        gnomAD_exome_ALL: '-',
        gnomAD_exome_AFR: '-',
        gnomAD_exome_AMR: '-',
        gnomAD_exome_EAS: '-',
        gnomAD_exome_FIN: '-',
        gnomAD_exome_NFE: '-',
        gnomAD_exome_SAS: '-',
        variationAbundance: '-',
        '1000g': '-',
        ExAC: '-',
        ALFA: '-',
        cnvPos: '-',
        chromosomeRegion: '-',
        len: '-',
        svType: '-',
        cnvOMIM: '-',
        cnvGene: '-',
        strPos: '-',
        RU: '-',
        GangSTR_repcn: '-',
        EH_repcn: '-',
        STRMax: '-',
        STR_Result: '-',
        SV_start: '-',
        start: '-',
        SV_end: '-',
        end: '-',
        SV_type: '-',
        sv_type: '-',
        'ref/alt(fre%)': '-',
        resultInterpretation: '-',
        resultInterpretation1: '',
        resultInterpretation2: '',
        resultInterpretation3: '',
        resultInterpretationCNV: '-',
        positiveInfo: '-',
        sangerResults: '',
        Articles: '',
        genetic_modes: '-',
        genetic_mode: '-',
        disease_description_cn: '-',
        Chromosomearm: ''
      }
    ]
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    if (
      props.template === '21' &&
      props.samples.length &&
      props.report.result === 'negative'
    ) {
      const data = {
        samples: props.samples.map(formatSampleInfo),
        sampleName: props.props.analysisInfo.name,
        clinicalInformation: props.affected_child_clinicalInformation,
        signature: props.signature,
        signature2: props.signature2,
        signature3: props.signature3,
        reportDate: formatDate(props.report.createdAt, 'YYYY-MM-DD')
      }

      setData(data)

      readStaticFile()
    } else if (
      props.template === '21' &&
      props.samples.length &&
      props.report.result === 'positive'
    ) {
      const Articles = props.reportsVariants
        .filter((item) => item.VariantsArticles && item.VariantsArticles.length)
        .map((row, index) => {
          const VariantsArticles = row.VariantsArticles ?? ([] as any[])

          return VariantsArticles.map((i: any) => {
            return {
              ...i,
              variantsType: row.variantsType
            }
          })
        })
        .flat()
        .map((row, index) => {
          row.Articles = `[${index + 1}] ${row.cite}`.replace(/<\/?b>/g, '')

          row.keyIndex = index + 1

          return row
        })

      //
      const variantKeyArticles = Articles.filter(
        (item) =>
          item.variantsType === 'KeyFinding' ||
          item.variantsType === 'IncidentalDiscovery'
      )
      const variantCarrierArticles = Articles.filter(
        (item) =>
          item.variantsType === 'CarrierScreening' ||
          item.variantsType === 'ACMGDiscovery' ||
          item.variantsType === 'OtherDiscovery'
      )

      const variantMTArticles = Articles.filter((row) => row.pos).filter(
        (row) => row.chrom === 'MT'
      )
      const detectionRawDataVariationList = props.isACMGSF
        ? props.detectionRawDataVariationList.map((row) => {
            const name = props.reportValue?.patient?.patientName
            const sampleType = t('Proband')

            row.acmgClass = judgeAcmg(
              row.user_acmg_classification
                ? row.user_acmg_classification
                : row.acmg_classification
                ? switchACMG(row.acmg_classification)
                : row.ACMG_classification
                ? row.ACMG_classification
                : row.classification
                ? row.classification
                : '-'
            )

            row.zygosity = processZygosity(row, true)

            row.OMIM_zh =
              row.OMIMData && row.OMIMData.length
                ? row.OMIMData?.map((i: any, index: number) => {
                    return `${index + 1}.${i.pheno_name_cn ?? '-'}(OMIM:${
                      i.phenoMim
                    })/${i.inheritance}`
                  }).join('\n')
                : '-'

            row.resultInterpretation1 = `    本次检测检出先证者存在`

            row.resultInterpretation2 = `${row.gene};${
              row.transcript ?? row.feature
            }:${row.c_nomen ?? row.hgvsc}(${row.p_nomen ?? row.hgvsp})`

            row.resultInterpretation3 = `变异。${
              row.VariantsArticles && row.VariantsArticles.length
                ? `已有该变异的相关报道${formatArray(
                    [
                      ...variantKeyArticles,
                      ...variantCarrierArticles,
                      ...variantMTArticles
                    ]
                      .filter((item) => item.keyId === row.keyId)
                      .map((item) => item.keyIndex)
                  )}`
                : '没有该变异的相关报道'
            }。依据ACMG指南，该变异被判断为${t(
              judgeAcmg(
                row.user_acmg_classification
                  ? row.user_acmg_classification
                  : row.ACMG_classification
              )
            )}，证据项为：${row.acmg_evidences
              ?.filter((i: string) => i && i !== '.')
              .join('+')}。该变异人群频率如下：`

            row['1000g'] = `${row.AF_1000g ? row.AF_1000g : '.'}`

            row['ExAC'] = `${row.AF_ExAC ? row.AF_ExAC : '.'}`

            row['ALFA'] = `${row.AF_ALFA ? row.AF_ALFA : '.'}`

            row.genetic_mode =
              row.newOMIMData && row.newOMIMData.length
                ? row.newOMIMData?.map((i: any, index: any) => {
                    return {
                      title: `${index + 1}、${i.disease ?? '-'}${
                        i.omimId ? `(OMIM:${i.omimId})` : ''
                      };${i.genetic_mode ?? '-'}`,
                      disease_description_cn: `    ${
                        i?.disease_description_cn ?? t('No Results')
                      }`
                    }
                  })
                : []
            const start = row.SV_start ?? row.start
            const end = row.SV_end ?? row.end
            const SV_type = row.SV_type ?? row.sv_type
            const len = row.LEN ?? row.sv_length
            const CN = row.CN ?? row.cn
            const AnnotSV_evidences = row.AnnotSV_evidences ?? row.score_details
            const geneLength = row?.gene_info
              ? row.gene_info?.omim_disease_genes?.length
              : row?.gene
              ? row.gene.split(',').length
              : 0

            row.resultInterpretationCNV = start
              ? `样本检出${row ? row.chrom : '**'}号染色体${
                  row ? `${start}:${end}` : '**'
                }区域约${row ? (len / 1024)?.toFixed(0) : '**'}Kb的${
                  SV_type
                    ? SV_type.toLocaleUpperCase() === 'DEL'
                      ? 'DEL （缺失）'
                      : 'DUP （重复）'
                    : ''
                }（拷贝数${
                  CN ? CN : '**'
                }），按照ACMG指南，该CNV的致病性评级为${
                  row ? row.ccnv_classification : '**'
                }。涉及${
                  geneLength ?? '**'
                }个RefSeq蛋白编码基因。致病证据:${AnnotSV_evidences}(annotsv证据).`
              : ''

            row.positiveInfo = `${
              row.ScipCnvDescription &&
              row.ScipCnvDescription.positiveInfo &&
              row.ScipCnvDescription.positiveInfo.length
                ? row.ScipCnvDescription.positiveInfo
                    .map((i: any) => (i18n.language === 'zh' ? i.zh : i.en))
                    .join(';')
                : '-'
            }`

            row.OMIMFlatArr = row.OMIMArr
              ? row.OMIMArr.map(
                  (i: any) => i?.geneDiseaseTranslated?.data ?? []
                )
                  .flat()
                  .map((i: any) => {
                    i.value = `${i?.disease}是一种常染色体显性遗传（${i?.genetic_mode}）疾病，患者常见临床表征有:${i.disease_description_cn}`

                    return i
                  })
              : []

            row.sangerResults = `${sampleType}-${name}-${row.gene};${
              row.transcript ?? row.feature
            }(MANE):${row.c_nomen ?? row.hgvsc}(${row.p_nomen ?? row.hgvsp})。`

            return row
          })
        : []

      const reportsVariants = props.reportsVariants.map((row) => {
        const name = props.reportValue?.patient?.patientName
        const sampleType = t('Proband')

        row.acmgClass = judgeAcmg(
          row.user_acmg_classification
            ? row.user_acmg_classification
            : row.acmg_classification
            ? switchACMG(row.acmg_classification)
            : row.ACMG_classification
            ? row.ACMG_classification
            : row.classification
            ? row.classification
            : '-'
        )
        row.zygosity = processZygosity(row, true)

        row.resultInterpretation1 = `    本次检测检出先证者存在`

        row.resultInterpretation2 = `${row.gene};${
          row.transcript ?? row.feature
        }:${row.c_nomen ?? row.hgvsc}(${row.p_nomen ?? row.hgvsp})`

        row.resultInterpretation3 = `变异。${
          row.VariantsArticles && row.VariantsArticles.length
            ? `已有该变异的相关报道${formatArray(
                [
                  ...variantKeyArticles,
                  ...variantCarrierArticles,
                  ...variantMTArticles
                ]
                  .filter((item) => item.keyId === row.keyId)
                  .map((item) => item.keyIndex)
              )}`
            : '没有该变异的相关报道'
        }。依据ACMG指南，该变异被判断为${t(
          judgeAcmg(
            row.user_acmg_classification
              ? row.user_acmg_classification
              : row.ACMG_classification
          )
        )}，证据项为：${row.acmg_evidences?.join('+')}。该变异人群频率如下：`

        row['1000g'] = `${row.AF_1000g ? row.AF_1000g : '.'}`

        row['ExAC'] = `${row.AF_ExAC ? row.AF_ExAC : '.'}`

        row['ALFA'] = `${row.AF_ALFA ? row.AF_ALFA : '.'}`

        row.genetic_mode =
          row.newOMIMData && row.newOMIMData.length
            ? row.newOMIMData?.map((i: any, index: any) => {
                return {
                  title: `${index + 1}、${i.disease ?? '-'}${
                    i.omimId ? `(OMIM:${i.omimId})` : ''
                  };${i.genetic_mode ?? '-'}`,
                  disease_description_cn: `    ${
                    i?.disease_description_cn ?? t('No Results')
                  }`
                }
              })
            : []

        row.OMIM_zh =
          row.newOMIMData && row.newOMIMData.length
            ? row.newOMIMData
                ?.map((i: any) => {
                  return `${i.disease ?? '-'}${
                    i.omimId ? `(OMIM:${i.omimId})` : ''
                  };${i.genetic_mode ?? '-'}`
                })
                .join('\n')
            : '-'
        const start = row.SV_start ?? row.start
        const end = row.SV_end ?? row.end
        const SV_type = row.SV_type ?? row.sv_type
        const len = row.LEN ?? row.sv_length
        const CN = row.CN ?? row.cn
        const AnnotSV_evidences = row.AnnotSV_evidences ?? row.score_details
        const geneLength = row?.gene_info
          ? row.gene_info?.omim_disease_genes?.length
          : row?.gene
          ? row.gene.split(',').length
          : 0

        row.resultInterpretationCNV = start
          ? `样本检出${row ? row.chrom : '**'}号染色体${
              start ? `${start}:${end}` : '**'
            }区域约${start ? (len / 1024)?.toFixed(0) : '**'}Kb的${
              SV_type
                ? SV_type.toLocaleUpperCase() === 'DEL'
                  ? 'DEL （缺失）'
                  : 'DUP （重复）'
                : ''
            }（拷贝数${CN ? CN : '**'}），按照ACMG指南，该CNV的致病性评级为${
              row ? row.ccnv_classification : '**'
            }。涉及${
              geneLength ?? '**'
            }个RefSeq蛋白编码基因。致病证据:${AnnotSV_evidences}(annotsv证据).`
          : ''

        row.positiveInfo = `${
          row.ScipCnvDescription &&
          row.ScipCnvDescription.positiveInfo &&
          row.ScipCnvDescription.positiveInfo.length
            ? row.ScipCnvDescription.positiveInfo
                .map((i: any) => (i18n.language === 'zh' ? i.zh : i.en))
                .join(';')
            : '-'
        }`

        row.OMIMFlatArr = row.OMIMArr
          ? row.OMIMArr.map((i: any) => i?.geneDiseaseTranslated?.data ?? [])
              .flat()
              .map((i: any) => {
                i.value = `${i?.disease}是一种常染色体显性遗传（${i?.genetic_mode}）疾病，患者常见临床表征有:${i.disease_description_cn}`

                return i
              })
          : []

        row.sangerResults = `${sampleType}-${name}-${row.gene};${
          row.transcript ?? row.feature
        }(MANE):${row.c_nomen ?? row.hgvsc}(${row.p_nomen ?? row.hgvsp})。`

        row.image = props.sanger.find(
          (i) => i.keyId === row.keyId || row.keyId?.includes(i.keyId)
        )?.base

        return row
      })
      const variantKey = reportsVariants
        .filter((item) => item.variantsType === 'KeyFinding')
        .filter((row) => row.pos)
        .filter((row) => row.chrom !== 'MT')
      const variantOther = reportsVariants
        .filter((item) => item.variantsType === 'IncidentalDiscovery')
        .filter((row) => row.pos)
        .filter((row) => row.chrom !== 'MT')
      const variantOthers = reportsVariants
        .filter((item) => item.variantsType === 'OtherDiscovery')
        .filter((row) => row.pos)
        .filter((row) => row.chrom !== 'MT')
      const variantCarrier = reportsVariants
        .filter(
          (item) =>
            item.variantsType === 'CarrierScreening' ||
            item.variantsType === 'ACMGDiscovery'
        )
        .filter((row) => row.pos)
        .filter((row) => row.chrom !== 'MT')
      const variantMT = reportsVariants
        .filter((row) => row.pos)
        .filter((row) => row.chrom === 'MT')
      const variantCnv = reportsVariants
        .filter((row) => row.SV_start || row.start)
        .filter((row) => !row.left_genes)

      const data = {
        samples: props.samples.map(formatSampleInfo),
        sampleName: props.props.analysisInfo.name,
        clinicalInformation: props.affected_child_clinicalInformation,
        showMainResultsArr1: variantKey.filter(
          (row) =>
            (row.ACMG_classification &&
              typeof row.ACMG_classification === 'string' &&
              (row.ACMG_classification.toLocaleLowerCase() === 'pathogenic' ||
                row.ACMG_classification.toLocaleLowerCase() ===
                  'likely pathogenic')) ||
            (row.user_acmg_classification &&
              typeof row.user_acmg_classification === 'string' &&
              (row.user_acmg_classification.toLocaleLowerCase() ===
                'pathogenic' ||
                row.user_acmg_classification.toLocaleLowerCase() ===
                  'likely pathogenic'))
        ).length
          ? [
              {
                mainResultsGene: `${variantKey.map((i) => i.gene).join(';')}`,
                mainResultsText: `1、主要结果：发现明确与所关注临床表型一致的致病性基因变异`
              }
            ]
          : [],

        showMainResults: variantKey.filter(
          (row) =>
            (row.ACMG_classification &&
              typeof row.ACMG_classification === 'string' &&
              (row.ACMG_classification.toLocaleLowerCase() === 'pathogenic' ||
                row.ACMG_classification.toLocaleLowerCase() ===
                  'likely pathogenic')) ||
            (row.user_acmg_classification &&
              typeof row.user_acmg_classification === 'string' &&
              (row.user_acmg_classification.toLocaleLowerCase() ===
                'pathogenic' ||
                row.user_acmg_classification.toLocaleLowerCase() ===
                  'likely pathogenic'))
        ).length
          ? ``
          : variantKey.filter(
              (row) =>
                (row.ACMG_classification &&
                  typeof row.ACMG_classification === 'string' &&
                  row.ACMG_classification.toLocaleLowerCase() ===
                    'uncertain significance') ||
                (row.user_acmg_classification &&
                  typeof row.user_acmg_classification === 'string' &&
                  row.user_acmg_classification.toLocaleLowerCase() ===
                    'uncertain significance')
            ).length
          ? `1、主要结果：发现明确与所关注临床表型一致的${variantKey
              .map((i) => i.gene)
              .join(';')}基因变异，Sanger测序验证结果见附录；`
          : '1、主要结果：未发现明确与所关注临床表型一致的致病性基因变异',
        secondaryResultsGene: `${variantOther.map((i) => i.gene).join(';')}`,
        secondaryResultsText: variantOther.length
          ? `2、次要结果：发现与受检者临床表型部分相关的基因变异，${variantOther
              .map((i) => i.gene)
              .join(';')}，Sanger测序验证结果见附录；`
          : `2、次要结果：未发现明确与所关注临床表型一致的致病性基因变异`,
        otherDiscoveriesGene: `${variantCarrier.map((i) => i.gene).join(';')}`,
        otherDiscoveriesText: variantCarrier.length
          ? `3、意外发现：发现与受检者表型不相关的基因变异，${variantCarrier
              .map((i) => i.gene)
              .join(';')}，详见补充报告（第 页）。`
          : `3、意外发现：未发现明确与所关注临床表型一致的致病性基因变异.`,

        CNVText: variantCnv.length
          ? `4、其他发现：发现与受检者临床表型可能相关的拷贝数变异，基于高通量全外的CNV检测不属于全外的常规检测范围，因此出具补充报告;详见 页`
          : `4、其他发现：未发现与受检者临床表型可能相关的拷贝数变异.`,
        showCnvArr: variantCnv.length
          ? [
              {
                CNVText: variantCnv.length
                  ? `其他发现：发现与受检者临床表型可能相关的拷贝数变异，基于高通量全外的CNV检测不属于全外的常规检测范围，因此出具补充报告;详见 页`
                  : `其他发现：未发现与受检者临床表型可能相关的拷贝数变异.`,
                variantCnv: variantCnv.length ? variantCnv : enmptyVariant,
                CnvOMIM: `${variantCnv
                  .map((row) => row.OMIMArr)
                  .flat()
                  .map((item: any) => item.omimData)
                  .flat()
                  .map((item: any) => `OMIM:${item.phenoMim}`)
                  .join(';')}`
              }
            ]
          : [],
        MTGene: `${variantMT.map((i) => `MT-${i.gene}`).join(';')}`,
        MTText: variantMT.length
          ? `5、其他发现：发现与受检者临床表型不相关线粒体${variantMT
              .map((i) => `MT-${i.gene}`)
              .join(
                ';'
              )}基因变异，由于与受检者表型不符，未能确定该变异与受检者临床症状是否有关系，因此出具补充报告基因变异，Sanger测序验证结果见附录；详见 页`
          : `5、其他发现：未发现明确与所关注临床表型一致的线粒体基因变异.`,
        variantKey:
          variantKey.length || variantOther.length
            ? [...variantKey, ...variantOther]
            : enmptyVariant,
        showKeyArr:
          variantKey.length || variantOther.length
            ? [
                {
                  variantKey:
                    variantKey.length || variantOther.length
                      ? [...variantKey, ...variantOther]
                      : enmptyVariant,
                  variantKeyArticles
                }
              ]
            : [],
        variantKeyClinicalInformation: unique(
          [...variantKey, ...variantOther],
          'gene'
        ),
        variantCarrier:
          variantCarrier.length || variantOthers.length
            ? [...variantCarrier, ...variantOthers]
            : enmptyVariant,
        variantCarrierClinicalInformation: unique(
          [...variantCarrier, ...variantOthers],
          'gene'
        ),
        showCarrierArr:
          variantCarrier.length ||
          variantOthers.length ||
          detectionRawDataVariationList.length
            ? [
                {
                  sampleName: props.props.analysisInfo.name,
                  variantCarrier: detectionRawDataVariationList.length
                    ? [...detectionRawDataVariationList]
                    : variantCarrier.length
                    ? [...variantCarrier, ...variantOthers]
                    : enmptyVariant,
                  variantCarrierClinicalInformation: unique(
                    [...variantCarrier, ...variantOthers],
                    'gene'
                  ),
                  variantCarrierArticles
                }
              ]
            : [],
        variantOther: variantOther.length ? variantOther : enmptyVariant,
        variantMT: variantMT.length ? variantMT : enmptyVariant,
        showMtArr: variantMT.length
          ? [
              {
                sampleName: props.props.analysisInfo.name,
                variantMT: variantMT.length ? variantMT : enmptyVariant,
                variantMTClinicalInformation: unique(variantMT, 'gene'),
                variantMTArticles
              }
            ]
          : [],
        variantOtherClinicalInformation: unique(variantMT, 'gene'),
        variantCnv: variantCnv.length ? variantCnv : enmptyVariant,
        variantKeyArticles,
        variantCarrierArticles,
        variantMTArticles,
        CnvTitle: `${variantCnv
          .map(
            (row) =>
              `46X${
                props.samples &&
                props.samples[0] &&
                props.samples[0].gender === 'male'
                  ? 'X'
                  : 'Y'
              },${(row.SV_type || row.sv_type).toLocaleLowerCase()}(${
                props.chromosomeData && props.chromosomeData.length
                  ? chromosomeRegion(
                      row.chrom,
                      row.SV_start || row.start,
                      row.SV_end || row.end,
                      props.chromosomeData.filter(
                        (item) => item['#chrom'] == row.chrom
                      )
                    )
                  : ''
              }).seq[GRCh37/hg19](${row.SV_start || row.start}-${
                row.SV_end || row.end
              })`
          )
          .join(';')}`,
        CnvOMIM: `${variantCnv
          .map((row) => row.OMIMArr)
          .flat()
          .map((item: any) => item.omimData)
          .flat()
          .map((item: any) => `OMIM:${item.phenoMim}`)
          .join(';')}`,
        signature: props.signature,
        signature2: props.signature2,
        signature3: props.signature3,
        reportDate: formatDate(props.report.createdAt, 'YYYY-MM-DD')
      }

      setData(data)

      readStaticFile()
    } else if (props.template === '22' && props.samples.length) {
      const variantKeyArticles = props.reportsVariants
        .filter((item) => item.VariantsArticles && item.VariantsArticles.length)
        .map((row, index) => {
          const VariantsArticles = row.VariantsArticles ?? ([] as any[])

          return VariantsArticles
        })
        .flat()
        .map((row, index) => {
          row.Articles = `[${index + 1}] ${row.cite}`.replace(/<\/?b>/g, '')

          return row
        })

      const reportsVariants = props.reportsVariants.map((row, index) => {
        row.acmgClass = judgeAcmg(
          row.user_acmg_classification
            ? row.user_acmg_classification
            : row.acmg_classification
            ? switchACMG(row.acmg_classification)
            : row.ACMG_classification
            ? row.ACMG_classification
            : row.classification
            ? row.classification
            : '-'
        )

        row.Exon = `${row.exon === '.' ? '-' : `(${row.exon})`}`

        row.Cnomen = row.c_nomen ?? row.hgvsc

        row.Mpos = `m.${row.pos}:${row.nuc_change}`

        row.cnvPos =
          (row.chrom && row.SV_start) || row.start
            ? `${row.chrom}:${row.SV_start || row.start}-${
                row.SV_end || row.end
              }`
            : '-'

        row.strPos =
          row.chrom && row.start ? `${row.chrom}:${row.start}-${row.end}` : '-'
        row.zygosity = processZygosity(row, true)

        const temp = props.strRang.find((item) => item.gene == row.gene)

        row.STRMax = temp ? `n < ${temp.max}` : '-'

        row.OMIM_zh =
          row.OMIMData && row.OMIMData.length
            ? row.OMIMData?.map((i: any) => {
                return `${i.inheritance}-${i.pheno_name_cn ?? '-'}(OMIM:${
                  i.phenoMim
                })`
              }).join('\n')
            : '-'

        row.cnvOMIM = row.inheritance
          ? row.inheritance
          : row.omim_info
          ? row.omim_info
              .filter((i: any) => i.inheritance && i.inheritance !== '.')
              .map((i: any) => `${i.inheritance}-${i.pheno_name_cn}`)
              .join(';')
          : '-'

        row.cnvGene = `${
          row.gene_info?.omim_disease_genes
            .map((item: any) => item.symbol)
            .join(';') ?? '-'
        }`

        row.resultInterpretation = `提示${row.gene};${
          row.transcript ?? row.feature
        }:${row.c_nomen ?? row.hgvsc}(${row.c_nomen ?? row.hgvsc})的突变为${t(
          judgeAcmg(
            row.user_acmg_classification
              ? row.user_acmg_classification
              : row.ACMG_classification
          )
        )}。`
        const start = row.SV_start ?? row.start
        const end = row.SV_end ?? row.end
        const SV_type = row.SV_type ?? row.sv_type
        const len = row.LEN ?? row.sv_length
        const CN = row.CN ?? row.cn
        const AnnotSV_evidences = row.AnnotSV_evidences ?? row.score_details
        const geneLength = row?.gene_info
          ? row.gene_info?.omim_disease_genes?.length
          : row?.gene
          ? row.gene.split(',').length
          : 0

        row.resultInterpretationCNV = `样本检出${
          row ? row.chrom : '**'
        }号染色体${row ? `${row.chrom}:${start}:${end}` : '**'}区域约${
          row ? (len / 1024)?.toFixed(0) : '**'
        }Kb的${
          row && SV_type
            ? SV_type.toLocaleUpperCase() === 'DEL'
              ? 'DEL （缺失）'
              : 'DUP （重复）'
            : ''
        }（拷贝数${CN ? CN : '**'}），按照ACMG指南，该CNV的致病性评级为${
          row ? row.ccnv_classification : '**'
        }。涉及${
          geneLength ? geneLength : '**'
        }个RefSeq蛋白编码基因。致病证据:${AnnotSV_evidences}(annotsv证据).`

        row.positiveInfo = `${
          row.ScipCnvDescription &&
          row.ScipCnvDescription.positiveInfo &&
          row.ScipCnvDescription.positiveInfo.length
            ? row.ScipCnvDescription.positiveInfo
                .map((i: any) => (i18n.language === 'zh' ? i.zh : i.en))
                .join(';')
            : '-'
        }`

        row.chromosomeRegion = `${
          props.chromosomeData && props.chromosomeData.length
            ? chromosomeRegion(
                row.chrom,
                start,
                end,
                props.chromosomeData.filter(
                  (item) => item['#chrom'] == row.chrom
                )
              )
            : '-'
        }`

        row.svType = SV_type
          ? SV_type.toLocaleUpperCase() === 'DEL'
            ? 'DEL （缺失）'
            : 'DUP （重复）'
          : '-'

        row.len = `${row.LEN ? (row.LEN / 1024)?.toFixed(0) : ''}Kb`

        row.OMIMFlatArr = row.OMIMArr
          ? row.OMIMArr.map((i: any) => i?.geneDiseaseTranslated?.data ?? [])
              .flat()
              .map((i: any) => {
                i.value = `${i?.disease}是一种常染色体显性遗传（${i?.genetic_mode}）疾病，患者常见临床表征有:${i.disease_description_cn}`

                return i
              })
          : []

        row.resultTitle = `${index + 1}）基因${row.gene}${
          row.chrom !== '.'
            ? `:${row.c_nomen ?? row.hgvsc}(${row.p_nomen ?? row.hgvsp})变异`
            : '-'
        }：${judgeAcmg(
          row.user_acmg_classification
            ? row.user_acmg_classification
            : row.ACMG_classification
            ? row.ACMG_classification
            : row.classification
        )}${row.acmg_evidences ? `（${row.acmg_evidences?.join(',')}）` : '-'}`

        row.acmgEvidences = row.acmg_evidences?.map((item: any) => {
          const first = item.split('_')[0]
          let text = ACMG_evidences_zh[first]

          const temp = props.userAcmgData.find(
            (log) =>
              log.variantKey ===
                `${row.gene}-${row.c_nomen ?? row.hgvsc}-${
                  row.transcript ?? row.feature
                }` &&
              `${first}${
                judgeStrength(item) ? `-${judgeStrength(item)}` : ''
              }` === log.acmgCriteria
          )

          if (first === 'PM2') {
            text = `GnomAD数据库中该变异频率为：${row.MAX_AF}`
          }

          return `${item}:${temp ? temp?.evidenceDetails : text}`
        })

        row.genetic_mode =
          row.newOMIMData && row.newOMIMData.length
            ? row.newOMIMData?.map((i: any, index: any) => {
                return {
                  title: `${index + 1}、${i.disease ?? '-'};${
                    i.genetic_mode ?? '-'
                  }`,
                  disease_description_cn: i.disease_description_cn,
                  phenotype: i.phenotype
                }
              })
            : []

        const name = props.reportValue?.patient?.patientName
        const sampleType = t('Proband')

        row.sangerResults = `${sampleType}-${name}-${row.gene};${
          row.transcript ?? row.feature
        }(MANE):${row.c_nomen ?? row.hgvsc}(${row.p_nomen ?? row.hgvsp})。`

        row.image = props.sanger.find(
          (i) => i.keyId === row.keyId || row.keyId?.includes(i.keyId)
        )?.base

        return row
      })
      const detectionMTVariationList = props.isACMGSF
        ? props.detectionMTVariationList.map((row) => {
            row['ref/alt(fre%)'] = `${row.coverage}[${(
              row.allele_frequency * 100
            )?.toFixed(2)}]`

            row.acmgClass = row.user_acmg_classification
              ? row.user_acmg_classification
              : row.ACMG_classification
              ? row.ACMG_classification
              : row.acmg_classification
              ? switchACMG(row.acmg_classification)
              : row.classification
              ? row.classification
              : '-'

            return row
          })
        : []
      const variantKey = reportsVariants
        .filter((item) => item.variantsType === 'KeyFinding')
        .filter((row) => row.pos)
        .filter((row) => row.chrom !== 'MT')
      const variantOther = reportsVariants
        .filter((item) => item.variantsType === 'IncidentalDiscovery')
        .filter((row) => row.pos)
        .filter((row) => row.chrom !== 'MT')
      const variantCarrier = reportsVariants
        .filter(
          (item) =>
            item.variantsType === 'CarrierScreening' ||
            item.variantsType === 'ACMGDiscovery'
        )
        .filter((row) => row.pos)
        .filter((row) => row.chrom !== 'MT')
      const variantMT = reportsVariants
        .filter((row) => row.pos)
        .filter((row) => row.chrom === 'MT')
      const variantCnv = reportsVariants
        .filter((row) => row.SV_start || row.start)
        .filter((row) => !row.left_genes)
      const variantSV = reportsVariants
        .filter((row) => row.SV_start || row.start)
        .filter((row) => row.left_genes)
      const variantSTR = reportsVariants
        .filter((row) => row.GangSTR_repcn)
        .filter((row) => row.GangSTR_repci)

      const data = {
        samples: props.samples.map(formatSampleInfo),
        sampleName: props.props.analysisInfo.name,
        clinicalInformation: props.affected_child_clinicalInformation,
        variantKey: variantKey.length ? [...variantKey] : enmptyVariant,
        variantKeyDesc: variantKey.length ? [...variantKey] : [],
        variantKeyClinicalInformation: unique([...variantKey], 'gene'),
        variantCarrier: variantCarrier.length
          ? [...variantCarrier]
          : enmptyVariant,
        variantCarrierClinicalInformation: unique(variantCarrier, 'gene'),
        variantOther: variantOther.length ? [...variantOther] : enmptyVariant,
        variantOtherDesc: variantOther.length ? [...variantOther] : [],
        variantMT: variantMT.length ? [...variantMT] : enmptyVariant,
        variantMTClinicalInformation: unique(variantMT, 'gene'),
        variantCnv: variantCnv.length ? [...variantCnv] : enmptyVariant,
        variantCnvDesc: variantCnv.length ? [...variantCnv] : [],
        variantSV: variantSV.length ? [...variantSV] : enmptyVariant,
        variantSTR: variantSTR.length ? [...variantSTR] : enmptyVariant,
        resultInterpretation: variantKey.length
          ? `根据ACMG指南，${variantKey
              .map((i) => i.resultInterpretation)
              .join(';')}`
          : '-',
        resultInterpretationOther: variantOther.length
          ? `根据ACMG指南，${variantOther
              .map((i) => i.resultInterpretation)
              .join(';')}`
          : '-',
        variantKeyArticles: variantKeyArticles,
        detectionMTVariationList: detectionMTVariationList.length
          ? [...detectionMTVariationList]
          : enmptyVariant,
        rohTitle:
          props.isRoh && props.currentRohList.length
            ? `本次检测，在受检者中检出第${props.currentRohList[0].chrom}号染色体(${props.currentRohList[0].begin}:${props.currentRohList[0].end})位置存在片段纯合。`
            : '无'
      }

      setData(data)

      readStaticFile()
    } else if (props.template === '23' && props.samples.length) {
      const reportsVariants = props.reportsVariants.map((row) => {
        const name = props.reportValue?.patient?.patientName
        const sampleType = t('Proband')

        row.chrompos = `Chr${row.chrom}:${row.pos}`
        row.pnomen = `${row.p_nomen ?? row.hgvsp}`.replace(/p\.(.*)/, 'p.($1)')

        row.cnvPos =
          (row.chrom && row.SV_start) || row.start
            ? `${row.chrom}:${row.SV_start ?? row.start}-${
                row.SV_end || row.end
              }`
            : '-'

        row.strPos =
          row.chrom && row.start ? `${row.chrom}:${row.start}-${row.end}` : '-'

        row.mtPos =
          row.chrom && row.pos && row.nuc_change
            ? `m.${row.pos}:${row.nuc_change}`
            : '-'
        const acmgClass = judgeAcmg(
          row.user_acmg_classification
            ? row.user_acmg_classification
            : row.acmg_classification
            ? switchACMG(row.acmg_classification)
            : row.ACMG_classification
            ? row.ACMG_classification
            : row.classification
            ? row.classification
            : '-'
        )

        row.coding_effect_zh = judgeVariantType(row.coding_effect)

        row.acmgClass = acmgClass
        row.zygosity = processZygosity(row, false)

        row.genetic_mode =
          row.newOMIMData && row.newOMIMData.length
            ? row.newOMIMData?.map((i: any, index: any) => {
                return {
                  title: `${index + 1}、${i.disease ?? '-'}${
                    i.omimId ? `(OMIM:${i.omimId})` : ''
                  };${i.genetic_mode ?? '-'}`,
                  disease_description_cn: i.disease_description_cn
                    ? `.疾病介绍：${i.disease_description_cn}`
                    : '.疾病介绍：-',
                  phenotype: i.phenotype
                    ? `.临床表型：${i.phenotype}`
                    : '.临床表型：-',
                  title2: `${i.genetic_mode ?? '-'}-${i.disease ?? '-'}${
                    i.omimId ? `(OMIM:${i.omimId})` : ''
                  }`,
                  title3: `${i.disease ?? '-'}(${formatSpecialInheritance(
                    i.genetic_mode ?? '-'
                  )})`
                }
              })
            : []

        row.OMIM_zh = row.genetic_mode.length
          ? row.genetic_mode.map((i: any) => i.title2).join(';')
          : '-'

        row.mainResultsOMIM_zh = row.genetic_mode.length
          ? row.genetic_mode.map((i: any) => i.title3).join(';')
          : '-'

        row.resultInterpretation =
          row.exon && row.exon.includes('/')
            ? `该变异位于${row.gene}基因的第${
                row.exon.split('/')[0]
              }号外显子，${parseMutation(
                row.c_nomen ?? row.hgvsc
              )}，导致编码蛋白的${formatAminoAcidMutation(
                row.p_nomen ?? row.hgvsp
              )}，依据ACMG指南，该变异被判断为${acmgClass}，证据项如下：`
            : `该变异位于${row.gene}基因，碱基"${row.REF}"变为"${row.ALT}"，依据ACMG指南，该变异被判断为${acmgClass}，证据项如下：`

        row.acmgEvidences = row.acmg_evidences?.filter(
          (item: any) => item !== '.'
        ).length
          ? row.acmg_evidences
              ?.filter((item: any) => item !== '.')
              .map((item: any) => {
                const first = item.split('_')[0]
                const second = item.split('_')[1]
                let text = ACMG_evidences_zh[first]

                const temp = props.userAcmgData.find(
                  (log) =>
                    log.variantKey ===
                      `${row.gene}-${row.c_nomen ?? row.hgvsc}-${
                        row.transcript ?? row.feature
                      }` && `${first}` === log.acmgCriteria.split('_')[0]
                )

                //

                if (first === 'PM2') {
                  text = `GnomAD数据库中该变异频率为：${row.MAX_AF}`
                }

                return {
                  text: `${judgeAcmgGrade(item)}：${
                    temp ? judgeEvidenceDetails(temp?.evidenceDetails) : text
                  }\n`
                }
              })
          : [
              {
                text: '/'
              }
            ]

        row.chromosomeRegion = `${
          props.chromosomeData && props.chromosomeData.length
            ? chromosomeRegion(
                row.chrom,
                row.SV_start ?? row.start,
                row.SV_end ?? row.end,
                props.chromosomeData.filter(
                  (item) => item['#chrom'] == row.chrom
                )
              )
            : '-'
        }`

        row.cnvOMIM = row.inheritance
          ? row.inheritance
          : row.omim_info
          ? row.omim_info
              .filter((i: any) => i.inheritance && i.inheritance !== '.')
              .map((i: any) => `${i.inheritance}-${i.pheno_name_cn}`)
              .join(';')
          : '-'

        row.cnvGene = `${
          row.gene_info?.omim_disease_genes
            .map((item: any) => item.symbol)
            .join(';') ?? '-'
        }`

        row.len = `${row.LEN ? (row.LEN / 1024)?.toFixed(0) : ''}Kb`

        row.svType =
          row.SV_type || row.sv_type
            ? (row.SV_type || row.sv_type).toLocaleUpperCase() === 'DEL'
              ? 'DEL （缺失）'
              : 'DUP （重复）'
            : '-'

        const temp = props.strRang.find((item) => item.gene == row.gene)

        row.STRMax = temp ? `n < ${temp.max}` : '-'

        row.variationAbundance = `${
          row.coverage
        }[${row.allele_frequency?.toFixed(2)}]`

        row.sangerResults = `${name}-${row.gene}(${
          row.transcript ?? row.feature
        }):${row.c_nomen ?? row.hgvsc}(${row.p_nomen ?? row.hgvsp})--阳性/阴性`

        row.image = props.sanger.find(
          (i) => i.keyId === row.keyId || row.keyId?.includes(i.keyId)
        )?.base

        return row
      })

      const detectionTumorVariationList = props.detectionTumorVariationList
        .filter((items) => {
          if (reportsVariants.find((item) => item.gene === items.gene))
            return false
          else return true
        })
        .map((row) => {
          row.chrompos = `Chr${row.chrom}:${row.pos}`
          row.pnomen = `${row.p_nomen ?? row.hgvsp}`.replace(
            /p\.(.*)/,
            'p.($1)'
          )
          row.zygosity = processZygosity(row, false)

          row.coding_effect_zh = judgeVariantType(row.coding_effect)

          row.genetic_mode =
            row.newOMIMData && row.newOMIMData.length
              ? row.newOMIMData?.map((i: any, index: any) => {
                  return {
                    title: `${index + 1}、${i.disease ?? '-'}${
                      i.omimId ? `(OMIM:${i.omimId})` : ''
                    };${i.genetic_mode ?? '-'}`,
                    disease_description_cn: i.disease_description_cn
                      ? `.疾病介绍：${i.disease_description_cn}`
                      : '.疾病介绍：-',
                    phenotype: i.phenotype
                      ? `.临床表型：${i.phenotype}`
                      : '.临床表型：-',
                    title2: `${i.genetic_mode ?? '-'}-${i.disease ?? '-'}${
                      i.omimId ? `(OMIM:${i.omimId})` : ''
                    }`,
                    title3: `${i.disease ?? '-'}(${formatSpecialInheritance(
                      i.genetic_mode ?? '-'
                    )})`
                  }
                })
              : []

          row.OMIM_zh = row.genetic_mode.length
            ? row.genetic_mode.map((i: any) => i.title2).join(';')
            : '-'

          row.mainResultsOMIM_zh = row.genetic_mode.length
            ? row.genetic_mode.map((i: any) => i.title3).join(';')
            : '-'

          const acmgClass = judgeAcmg(
            row.user_acmg_classification
              ? row.user_acmg_classification
              : row.acmg_classification
              ? switchACMG(row.acmg_classification)
              : row.ACMG_classification
              ? row.ACMG_classification
              : row.classification
              ? row.classification
              : '-'
          )

          row.acmgClass = acmgClass
          const c_pos = `${row.c_nomen ?? row.hgvsc}`.match(/c\.(\d+)/)

          row.resultInterpretation =
            row.exon && row.exon.includes('/')
              ? `该变异位于${row.gene}基因的第${
                  row.exon.split('/')[0]
                }号外显子，${parseMutation(
                  row.c_nomen ?? row.hgvsc
                )}，导致编码蛋白的${formatAminoAcidMutation(
                  row.p_nomen ?? row.hgvsp
                )}，依据ACMG指南，该变异被判断为${acmgClass}，证据项如下：`
              : `该变异位于${row.gene}基因，碱基"${row.REF}"变为"${row.ALT}"，依据ACMG指南，该变异被判断为${acmgClass}，证据项如下：`

          row.acmgEvidences = row.acmg_evidences?.filter(
            (item: any) => item !== '.'
          ).length
            ? row.acmg_evidences
                ?.filter((item: any) => item !== '.')
                .map((item: any) => {
                  const first = item.split('_')[0]
                  const second = item.split('_')[1]
                  let text = ACMG_evidences_zh[first]

                  const temp = props.userAcmgData.find(
                    (log) =>
                      log.variantKey ===
                        `${row.gene}-${row.c_nomen ?? row.hgvsc}-${
                          row.transcript ?? row.feature
                        }` && `${first}` === log.acmgCriteria.split('_')[0]
                  )

                  //

                  if (first === 'PM2') {
                    text = `GnomAD数据库中该变异频率为：${row.MAX_AF}`
                  }

                  return {
                    text: `${judgeAcmgGrade(item)}：${
                      temp ? judgeEvidenceDetails(temp?.evidenceDetails) : text
                    }\n`
                  }
                })
            : [
                {
                  text: '/'
                }
              ]

          return row
        })
      const variantKey = reportsVariants
        .filter((item) => item.variantsType === 'KeyFinding')
        .filter((row) => row.pos)
        .filter((row) => row.chrom !== 'MT')
        .filter(
          (row) =>
            (row.ACMG_classification &&
              typeof row.ACMG_classification === 'string' &&
              (row.ACMG_classification.toLocaleLowerCase() === 'pathogenic' ||
                row.ACMG_classification.toLocaleLowerCase() ===
                  'likely pathogenic')) ||
            (row.user_acmg_classification &&
              typeof row.user_acmg_classification === 'string' &&
              (row.user_acmg_classification.toLocaleLowerCase() ===
                'pathogenic' ||
                row.user_acmg_classification.toLocaleLowerCase() ===
                  'likely pathogenic'))
        )
      const variantOthers = reportsVariants
        .filter(
          (item) =>
            item.variantsType === 'IncidentalDiscovery' ||
            item.variantsType === 'OtherDiscovery'
        )
        .filter((row) => row.pos)
        .filter((row) => row.chrom !== 'MT')
      const variantCarrier = reportsVariants
        .filter(
          (item) =>
            item.variantsType === 'CarrierScreening' ||
            item.variantsType === 'ACMGDiscovery'
        )
        .filter((row) => row.pos)
        .filter((row) => row.chrom !== 'MT')
      const variantMT = reportsVariants
        .filter((row) => row.pos)
        .filter((row) => row.chrom === 'MT')
      const variantKeyCnv = reportsVariants
        .filter((item) => item.variantsType === 'KeyFinding')
        .filter((row) => row.SV_start || row.start)
        .filter((row) => !row.left_genes)
      const variantOtherCnv = reportsVariants
        .filter(
          (item) =>
            item.variantsType === 'IncidentalDiscovery' ||
            item.variantsType === 'OtherDiscovery'
        )
        .filter((row) => row.SV_start || row.start)
        .filter((row) => !row.left_genes)
      const variantKeySTR = reportsVariants
        .filter((item) => item.variantsType === 'KeyFinding')
        .filter((row) => row.GangSTR_repcn)
        .filter((row) => row.GangSTR_repci)
      const variantOtherSTR = reportsVariants
        .filter(
          (item) =>
            item.variantsType === 'IncidentalDiscovery' ||
            item.variantsType === 'OtherDiscovery'
        )
        .filter((row) => row.GangSTR_repcn)
        .filter((row) => row.GangSTR_repci)
      const variantKeySV = reportsVariants
        .filter((item) => item.variantsType === 'KeyFinding')
        .filter((row) => row.SV_start || row.start)
        .filter((row) => row.left_genes)
      const variantOtherSV = reportsVariants
        .filter(
          (item) =>
            item.variantsType === 'IncidentalDiscovery' ||
            item.variantsType === 'OtherDiscovery'
        )
        .filter((row) => row.SV_start || row.start)
        .filter((row) => row.left_genes)
      const variantTumor: any[] = detectionTumorVariationList

      const mainResultsText = [
        variantKey.filter(
          (row) =>
            (row.ACMG_classification &&
              typeof row.ACMG_classification === 'string' &&
              (row.ACMG_classification.toLocaleLowerCase() === 'pathogenic' ||
                row.ACMG_classification.toLocaleLowerCase() ===
                  'likely pathogenic')) ||
            (row.user_acmg_classification &&
              typeof row.user_acmg_classification === 'string' &&
              (row.user_acmg_classification.toLocaleLowerCase() ===
                'pathogenic' ||
                row.user_acmg_classification.toLocaleLowerCase() ===
                  'likely pathogenic'))
        ).length
          ? `本次检测发现与${variantKey
              .map((i) => i.mainResultsOMIM_zh)
              .join(' 和 ')}相关的SNV/INDEL${changeAcmgText(
              variantKey.map((i) => i.acmgClass)
            )}变异，请结合临床并进行遗传咨询。`
          : `未发现明确与所关注临床表型一致的致病性基因变异。`,

        // variantKey.filter(
        //   (row) =>
        //     (row.ACMG_classification &&
        //       row.ACMG_classification.toLocaleLowerCase() ===
        //         'uncertain significance') ||
        //     (row.user_acmg_classification &&
        //       row.user_acmg_classification.toLocaleLowerCase() ===
        //         'uncertain significance')
        // ).length
        //   ? `本次检测发现与${variantKey
        //       .map((i) => i.mainResultsOMIM_zh)
        //       .join(
        //         ' 和 '
        //       )}相关的SNV/INDEL致病/可能致病变异，请结合临床并进行遗传咨询。`
        //   : `未发现明确与所关注临床表型一致的意义未明基因变异`,
        variantOthers.filter(
          (row) =>
            (row.ACMG_classification &&
              typeof row.ACMG_classification === 'string' &&
              row.ACMG_classification.toLocaleLowerCase() ===
                'uncertain significance') ||
            (row.user_acmg_classification &&
              typeof row.user_acmg_classification === 'string' &&
              row.user_acmg_classification.toLocaleLowerCase() ===
                'uncertain significance')
        ).length
          ? `本次检测发现与${variantOthers
              .map((i) => i.mainResultsOMIM_zh)
              .join(' 和 ')}相关的SNV/INDEL${changeAcmgText(
              variantOthers.map((i) => i.acmgClass)
            )}变异，请结合临床并进行遗传咨询。`
          : `未发现明确与所关注临床表型一致的意义未明基因变异。`,
        [...variantKeyCnv, ...variantKeySV].length
          ? `本次检测根据软件预测出与${variantKey
              .map((i) => `${i.mainResultsOMIM_zh}`)
              .join(
                ' 和 '
              )}大片段缺失重复或结构变异，请结合临床并进行遗传咨询。`
          : ``,
        variantKeySTR.length
          ? `本次检测根据软件预测出与${variantKey
              .map((i) => `${i.mainResultsOMIM_zh}`)
              .join(' 和 ')}短序列重复变异，请结合临床并进行遗传咨询。`
          : ``
      ]
        .filter((item) => item)
        .map((item, index) => {
          return {
            text: `1.${index + 1} ${item}`,
            key: index
          }
        })

      const secondaryResultsText = [
        variantOthers.filter(
          (row) =>
            (row.ACMG_classification &&
              typeof row.ACMG_classification === 'string' &&
              (row.ACMG_classification.toLocaleLowerCase() === 'pathogenic' ||
                row.ACMG_classification.toLocaleLowerCase() ===
                  'likely pathogenic')) ||
            (row.user_acmg_classification &&
              typeof row.user_acmg_classification === 'string' &&
              (row.user_acmg_classification.toLocaleLowerCase() ===
                'pathogenic' ||
                row.user_acmg_classification.toLocaleLowerCase() ===
                  'likely pathogenic'))
        ).length
          ? `本次检测发现与${variantOthers
              .map((i) => i.mainResultsOMIM_zh)
              .join(' 和 ')}相关的SNV/INDEL${changeAcmgText(
              variantOthers.map((i) => i.acmgClass)
            )}变异，请结合临床并进行遗传咨询。`
          : `未检测到可以部分解释患者表型的致病/可能致病变异。`,
        [...variantOtherCnv, ...variantOtherSV].length
          ? `本次检测根据软件预测出与${[...variantOtherCnv, ...variantOtherSV]
              .map((i) => `${i.mainResultsOMIM_zh}`)
              .join(
                ' 和 '
              )}大片段缺失重复或结构变异，请结合临床并进行遗传咨询。`
          : ``,
        variantMT.length
          ? `本次检测根据软件预测出与${variantMT
              .map((i) => `${i.mainResultsOMIM_zh}`)
              .join(' 和 ')}线粒体变异，请结合临床并进行遗传咨询。`
          : ``,
        variantOtherSTR.length
          ? `本次检测根据软件预测出与${variantOtherSTR
              .map((i) => `${i.mainResultsOMIM_zh}`)
              .join(' 和 ')}短序列重复变异，请结合临床并进行遗传咨询。`
          : ``
      ]
        .filter((item) => item)
        .map((item, index) => {
          return {
            text: `2.${index + 1} ${item}`,
            key: index
          }
        })

      const CarrierResultsText = [
        {
          text: variantCarrier.length
            ? `3.1在ACMG推荐可干预基因中，本次检测意外发现与${variantCarrier
                .map((i) => `${i.mainResultsOMIM_zh}`)
                .join(' 和 ')}相关的SNV/INDEL${changeAcmgText(
                variantCarrier.map((i) => i.acmgClass)
              )}变异。请结合临床并进行遗传咨询。`
            : `3.1未检测到在ACMG推荐可干预基因中的致病/可能致病 SNV/INDEL变异。`,
          key: 'acmg'
        },
        {
          text: variantTumor.length
            ? `3.2在肿瘤推荐检测基因中，本次检测意外发现与${variantTumor
                .map((i) => `${i.mainResultsOMIM_zh}`)
                .join(' 和 ')}相关的SNV/INDEL${changeAcmgText(
                variantTumor.map((i) => i.acmgClass)
              )}变异。请结合临床并进行遗传咨询。`
            : `3.2未检测到在肿瘤推荐检测基因中的致病/可能致病 SNV/INDEL变异。`,
          key: 'carrier'
        }
      ]

      const enmptyVariantText = [
        {
          text: `未检测到可以部分解释患者表型的致病/可能致病变异。`,
          key: 'empty'
        }
      ]

      const variantKeySVAndCNV = [...variantKeySV, ...variantKeyCnv]
      const variantOtherSVAndCNV = [...variantOtherSV, ...variantOtherCnv]

      const data = {
        samples: props.samples.map((sample) => {
          const fastQc = sample.fastQc ?? {}
          const metricsData = fastQc.metricsData ?? {}
          const rawReads = metricsData.rawReads ?? '-'
          const totalBases =
            rawReads === '-'
              ? '-'
              : `${
                  Math.round(
                    (Number(
                      `${calculateAndFormat(`${rawReads}`, 150)}`.replace(
                        /,/g,
                        ''
                      )
                    ) /
                      1e9) *
                      100
                  ) / 100
                }G`
          const readsMappedPercent = metricsData.readsMappedPercent ?? '-'
          const pctData = (fastQc.barChartData ?? []) as any[]
          const x1 = `${
            pctData.find((i) => i.name === '1x')?.value?.toFixed(2) ?? '-'
          }%`
          const x10 = `${
            pctData.find((i) => i.name === '10x')?.value?.toFixed(2) ?? '-'
          }%`
          const x20 = `${
            pctData.find((i) => i.name === '20x')?.value?.toFixed(2) ?? '-'
          }%`
          const seqtk_q30 =
            metricsData.seqtk_q30 && Array.isArray(metricsData.seqtk_q30)
              ? metricsData.seqtk_q30
              : []

          const q30 = `${
            seqtk_q30[0]?.average_Q30
              ? seqtk_q30[0]?.average_Q30
              : seqtk_q30[0]?.avg_q30
              ? seqtk_q30[0]?.avg_q30
              : '-'
          }%`

          return {
            patientName: sample.patient?.patientName,
            sampleName: sample.sample?.name,
            gender: t(sample.patient?.gender ?? '-'),
            caseNumber: sample.patient?.caseNumber ?? '-',
            phenotype: sample.patient?.phenotype ?? '-',
            resultsIn: sample.patient?.resultsIn ?? '-',
            sampleCode: sample?.sample?.sampleCode ?? '-',
            dateOfBirth:
              formatDate(sample.patient?.dateOfBirth, 'YYYY-MM-DD') ?? '-',
            birthDay: `${
              sample.patient?.dateOfBirth
                ? (Math.floor(
                    (new Date().valueOf() -
                      new Date(sample.patient?.dateOfBirth).valueOf()) /
                      3.15576e10
                  ) <= 0
                    ? 0
                    : Math.floor(
                        (new Date().valueOf() -
                          new Date(sample.patient?.dateOfBirth).valueOf()) /
                          3.15576e10
                      )) + '岁'
                : '-'
            }`,
            fileSize: sample.sample?.fileSize
              ? sample.sample?.fileSize > 1000
                ? `${(sample.sample?.fileSize / 1024)?.toFixed(2) ?? '-'}G`
                : `${sample.sample?.fileSize}MB`
              : '-',
            collectDate:
              formatDate(sample.patient?.arrivalDate, 'YYYY-MM-DD') ?? '-',
            arrivalDate:
              formatDate(sample.patient?.receiveDate, 'YYYY-MM-DD') ?? '-',
            infirmaryName: sample.patient?.infirmaryName ?? '-',
            rawReads: rawReads ? `${readsMappedPercent}` : `-`,
            totalBases: totalBases,
            avgReadDepth: `${sample.sample?.avgReadDepth?.toFixed(2) ?? '-'}`,
            x1,
            x10,
            x20,
            q30
          }
        }),
        sampleName: props.props.analysisInfo.name,
        exportDate: formatDate(new Date(), 'YYYY-MM-DD'),
        sampleCode: props.samples[0]?.sample?.sampleCode ?? '-',
        caseNumber: props.samples[0]?.patient?.caseNumber ?? '-',
        clinicalInformation: props.affected_child_clinicalInformation,
        mainResultsGene: `${variantKey.map((i) => i.gene).join(';')}`,
        mainResultsOMIM: `${variantKey
          .map((i) => i.mainResultsOMIM_zh)
          .join(';')}`,
        mainResultsText: mainResultsText.length
          ? mainResultsText
          : enmptyVariantText,
        secondaryResultsText: secondaryResultsText.length
          ? secondaryResultsText
          : enmptyVariantText,
        CarrierResultsText: CarrierResultsText,
        MTGene: `${variantMT.map((i) => `MT-${i.gene}`).join(';')}`,
        variantKey: variantKey.length ? [...variantKey] : [],
        variantKeyNone: !variantKey.length ? enmptyVariant : [],
        variantOther: variantOthers.length ? variantOthers : [],
        variantOtherNone: !variantOthers.length ? enmptyVariant : [],
        variantCarrier: variantCarrier.length ? [...variantCarrier] : [],
        variantCarrierNone: !variantCarrier.length ? enmptyVariant : [],
        variantMT: variantMT.length ? variantMT : [],
        variantMTNone: !variantMT.length ? enmptyVariant : [],
        variantKeySTR: variantKeySTR.length ? variantKeySTR : [],
        variantKeySTRNone: !variantKeySTR.length ? enmptyVariant : [],
        variantOtherSTR: variantOtherSTR.length ? variantOtherSTR : [],
        variantOtherSTRNone: !variantOtherSTR.length ? enmptyVariant : [],
        variantKeySVAndCNV: variantKeySVAndCNV.length ? variantKeySVAndCNV : [],
        variantKeySVAndCNVNone: !variantKeySVAndCNV.length ? enmptyVariant : [],
        variantOtherSVAndCNV: variantOtherSVAndCNV.length
          ? variantOtherSVAndCNV
          : [],
        variantOtherSVAndCNVNone: !variantOtherSVAndCNV.length
          ? enmptyVariant
          : [],
        variantAll: [...variantKey, ...variantOthers, ...variantCarrier],
        variantAllSangerResults: [...variantKey, ...variantOthers].filter(
          (row) =>
            (row.ACMG_classification &&
              typeof row.ACMG_classification === 'string' &&
              (row.ACMG_classification.toLocaleLowerCase() === 'pathogenic' ||
                row.ACMG_classification.toLocaleLowerCase() ===
                  'likely pathogenic')) ||
            (row.user_acmg_classification &&
              typeof row.user_acmg_classification === 'string' &&
              (row.user_acmg_classification.toLocaleLowerCase() ===
                'pathogenic' ||
                row.user_acmg_classification.toLocaleLowerCase() ===
                  'likely pathogenic'))
        ).length
          ? unique([...variantKey, ...variantOthers], 'sangerResults')
          : [
              {
                sangerResults: `未检测到与临床表型高度相关，且致病性证据较为充分的单核苷酸变异(SNV)、短片段插入/缺失(Indel)。`
              }
            ],
        variantTumor: variantTumor.length ? variantTumor : [],
        variantTumorNone: !variantTumor.length ? enmptyVariant : [],

        // variantKey: variantKey,
        // variantKeyLength: variantKey.length >= 1,
        // variantOther: variantOthers,
        // variantOtherLength: variantOthers.length  >= 1,
        // variantCarrier: variantCarrier,
        // variantCarrierLength: variantCarrier.length  >= 1,
        // variantMT: variantMT,
        // variantMTLength: variantMT.length  >= 1,
        // variantKeySTR: variantKeySTR,
        // variantKeySTRLength: variantKeySTR.length  >= 1,
        // variantOtherSTR: variantOtherSTR,
        // variantOtherSTRLength: variantOtherSTR.length  >= 1,
        // variantKeySVAndCNV: variantKeySVAndCNV,
        // variantKeySVAndCNVLength: variantKeySVAndCNV.length  >= 1,
        // variantOtherSVAndCNV: variantOtherSVAndCNV,
        // variantOtherSVAndCNVLength: variantOtherSVAndCNV.length  >= 1,
        samplesLength: props.samples.length
      }

      setData(data)

      readStaticFile()
    } else if (
      (props.template === '24' ||
        props.template === '25' ||
        props.template === '26') &&
      props.samples.length
    ) {
      const reportsArticles = props.reportsVariants
        .filter((item) => item.VariantsArticles && item.VariantsArticles.length)
        .map((row, index) => {
          const VariantsArticles = row.VariantsArticles ?? ([] as any[])

          return VariantsArticles.map((i: any) => {
            return {
              ...i,
              variantsType: row.variantsType
            }
          })
        })
        .flat()
        .map((row, index) => {
          row.Articles = ` ${row.cite_shengxiang}\n`.replace(/<\/?b>/g, '')

          row.keyIndex = index + 1

          return row
        })
      const otherArticles = [
        {
          Articles:
            'Manickam K, McClain MR, Greiner KE, et al. Exome and genome sequencing for pediatric patients with congenital anomalies, intellectual disability, or global developmental delay: an ACMG evidence-based clinical practice guideline [J]. Genet Med, 2021.',
          variantsType: 'KeyFinding'
        },
        {
          Articles:
            'Lee K, Mahoney KE, Amendola LM, et al. ACMG SF v3.3 list for reporting of secondary findings in clinical exome and genome sequencing: A policy statement of the American College of Medical Genetics and Genomics [J]. Genet Med, 2025.',
          variantsType: 'KeyFinding'
        },
        {
          Articles: '国家卫生健康委员会.第一批罕见病目录 [Z].2018.',
          variantsType: 'KeyFinding'
        },
        {
          Articles:
            'Richards S, Aziz N, Bale S, et al. Standards and guidelines for the interpretation of sequence variants: a joint consensus recommendation of the American College of Medical Genetics and Genomics and the Association for Molecular Pathology[J]. Genet Med, 2015.',
          variantsType: 'KeyFinding'
        }
      ]
      const Articles =
        reportsArticles.length > 7
          ? [...otherArticles, ...reportsArticles.slice(0.6)].map(
              (i, index) => {
                return {
                  ...i,
                  Articles: `[${index + 1}]${i.Articles}`
                }
              }
            )
          : [...otherArticles, ...reportsArticles].map((i, index) => {
              return {
                ...i,
                Articles: `[${index + 1}]${i.Articles}`
              }
            })

      //
      const variantKeyArticles = Articles.filter(
        (item) => item.variantsType === 'KeyFinding'
      )
      const variantCarrierArticles = Articles.filter(
        (item) => item.variantsType === 'IncidentalDiscovery'
      )

      const reportsVariants = props.reportsVariants.map((row) => {
        const name = props.reportValue?.patient?.patientName
        const sampleType = t('Proband')

        const acmgClass = judgeAcmg(
          row.user_acmg_classification
            ? switchACMG(row.user_acmg_classification)
            : row.acmg_classification
            ? switchACMG(row.acmg_classification)
            : row.ACMG_classification
            ? row.ACMG_classification
            : row.classification
            ? row.classification
            : '-'
        )
        row.Chromosomearm = row.Chromosomearm ?? ''
        row.acmgClass = acmgClass
        row.zygosity = processZygosity(row, false)

        row.resultInterpretation3 =
          row.exon && row.exon.includes('/')
            ? `该变异位于${row.gene}基因的第${
                row.exon.split('/')[0]
              }号外显子，${parseMutation(
                row.c_nomen ?? row.hgvsc
              )}，导致编码蛋白的${formatAminoAcidMutation(
                row.p_nomen ?? row.hgvsp
              )}，依据ACMG指南，该变异被判断为${acmgClass}，证据项如下：`
            : `该变异位于${row.gene}基因，碱基"${row.REF}"变为"${row.ALT}"，依据ACMG指南，该变异被判断为${acmgClass}，证据项如下：`
        row.resultInterpretation2 = `${row.gene};${
          row.transcript ?? row.feature
        }:${row.c_nomen ?? row.hgvsc}(${row.p_nomen ?? row.hgvsp})，`

        row.genetic_mode =
          row.newOMIMData && row.newOMIMData.length
            ? row.newOMIMData?.map((i: any, index: any) => {
                return {
                  title: `${index + 1}、${i.disease ?? '-'}${
                    i.omimId ? `(OMIM:${i.omimId})` : ''
                  };${i.genetic_mode ?? '-'}`,
                  disease_description_cn: `${
                    i?.disease_description_cn ?? t('No Results')
                  }`
                    .replace(/\(/g, '（')
                    .replace(/\)/g, '）')
                }
              })
            : row.MitoMap
            ? [
                {
                  title: row.MitoMap.disease_ch,
                  disease_description_cn: row.MitoMap.disease_ch
                }
              ]
            : [
                {
                  title: '/',
                  disease_description_cn: '/'
                }
              ]

        row.OMIM_zh =
          row.newOMIMData && row.newOMIMData.length
            ? row.newOMIMData
                ?.map((i: any) => {
                  return `${i.disease ?? '-'};${i.genetic_mode ?? '-'}`
                })
                .join('\n')
            : row.MitoMap
            ? row.MitoMap.disease_ch
            : '/'

        row.OMIM_zhs =
          row.newOMIMData && row.newOMIMData.length
            ? row.newOMIMData?.map((i: any) => {
                return {
                  text: `${i.disease ?? '-'};${i.genetic_mode ?? '-'}`
                }
              })
            : row.MitoMap
            ? [
                {
                  text: `${row.MitoMap.disease_ch}(Mi)`
                }
              ]
            : [
                {
                  text: '/'
                }
              ]

        row.acmgEvidences = row.acmg_evidences?.filter(
          (item: any) => item !== '.'
        ).length
          ? row.acmg_evidences
              ?.filter((item: any) => item !== '.')
              .map((item: any) => {
                const first = item.split('_')[0]
                const second = item.split('_')[1]
                let text = ACMG_evidences_zh[first]

                const temp = props.userAcmgData.find(
                  (log) =>
                    log.variantKey ===
                      `${row.gene}-${row.c_nomen ?? row.hgvsc}-${
                        row.transcript ?? row.feature
                      }` && `${first}` === log.acmgCriteria.split('_')[0]
                )

                //

                if (first === 'PM2' && row.MAX_AF) {
                  text = `GnomAD数据库中该变异频率为：${row.MAX_AF}`
                }

                return {
                  text: `${judgeAcmgGrade(item)}：${
                    temp ? judgeEvidenceDetails(temp?.evidenceDetails) : text
                  }\n`
                }
              })
          : [
              {
                text: '/'
              }
            ]

        row.sangerResults = `${sampleType}-${name}-${row.gene};${
          row.transcript ?? row.feature
        }(MANE):${row.c_nomen ?? row.hgvsc}(${row.p_nomen ?? row.hgvsp})。`

        row.image = props.sanger.find(
          (i) => i.keyId === row.keyId || row.keyId?.includes(i.keyId)
        )?.base

        if (row.chrom === 'MT') {
          row.c_nomen = `${row.ref}>${row.alt}`
          row.p_nomen = '/'

          row.resultInterpretation2 = `${row.gene};${
            row.transcript ?? row.feature
          }:(${row.c_nomen})，`
        }

        if (row.variant_type === 'CNV') {
          const start = row.SV_start ?? row.start
          const end = row.SV_end ?? row.end
          const SV_type = row.SV_type ?? row.sv_type
          const len = row.LEN ?? row.sv_length
          const CN = row.CN ?? row.cn
          const AnnotSV_evidences = row.AnnotSV_evidences ?? row.score_details
          const geneLength = row?.gene_info
            ? row.gene_info?.omim_disease_genes?.length
            : row?.gene
            ? row.gene.split(',').length
            : 0
          row.c_nomen =
            SV_type.toLocaleUpperCase() === 'DEL'
              ? 'DEL （缺失）'
              : 'DUP （重复）'
          row.p_nomen = `${len}bp`

          row.gene = row.omim_genes.map((i: any) => i.gene).join(',')

          row.resultInterpretation3 = start
            ? `样本检出${row ? row.chrom : '**'}号染色体${
                row ? `${start}:${end}` : '**'
              }区域约${row ? (len / 1024)?.toFixed(0) : '**'}Kb的${
                SV_type
                  ? SV_type.toLocaleUpperCase() === 'DEL'
                    ? 'DEL （缺失）'
                    : 'DUP （重复）'
                  : ''
              }（拷贝数${CN ? CN : '**'}），按照ACMG指南，该CNV的致病性评级为${
                row ? row.ccnv_classification : '**'
              }。涉及${
                geneLength ?? '**'
              }个RefSeq蛋白编码基因。致病证据:${AnnotSV_evidences}(annotsv证据).`
            : ''

          row.resultInterpretation2 = ''
        }

        return row
      })
      const variantKey = reportsVariants.filter(
        (item) => item.variantsType === 'KeyFinding'
      )
      const variantOther = reportsVariants.filter(
        (item) => item.variantsType === 'IncidentalDiscovery'
      )
      const tempRohOMIMText =
        props.isRoh && props.currentRohList.length
          ? rohOMIM
              .filter((i) => i.chrom == props.currentRohList[0].chromIndex)
              ?.map((i) => i.phenotype)
              .join(';') ?? ''
          : ''

      const data = {
        samples: props.samples.map(formatSampleInfo),
        sampleName: props.props.analysisInfo.name,
        patientName: props.reportValue?.patient?.patientName,
        caseNumber: props.samples[0]?.patient?.caseNumber ?? '-',
        clinicalInformation: props.affected_child_clinicalInformation,
        mainResultsText: variantKey.length
          ? `检出与临床症状相关的${variantKey.length}个变异；`
          : '没有检出与临床症状相关的变异；',
        secondaryResultsText: variantOther.length
          ? `检出与被检测者表型关联尚不明确的${variantOther.length}个变异。`
          : `没有检出与被检测者表型关联尚不明确的变异。`,
        variantKey: variantKey.length ? [...variantKey] : enmptyVariant,
        variantOther: variantOther.length ? variantOther : enmptyVariant,
        variantArticles: [...variantKeyArticles, ...variantCarrierArticles],
        signature: props.signature,
        signature2: props.signature2,
        signature3: props.signature3,
        signature4: props.signature4,
        reportDate: formatDate(props.report.createdAt, 'YYYY-MM-DD'),
        title1: variantKey.length ? '疾病介绍' : '',
        title2: variantOther.length ? '疾病介绍' : '',
        rohTitle:
          props.isRoh && props.currentRohList.length
            ? `本次检测，在受检者中检出第${
                props.currentRohList[0].chrom
              }号染色体(${props.currentRohList[0].begin}:${
                props.currentRohList[0].end
              })位置存在片段纯合，对应相关疾病:${
                tempRohOMIMText ? tempRohOMIMText : '无'
              }，需要其他方法进一步验证。`
            : '本次检测，没有发现可疑的异常纯合子区域（ROH）。'
      }

      setData(data)

      readStaticFile()
    }
  }, [
    props.reportsVariants.length,
    props.samples.length,
    props.template,
    props.sanger.length,
    props.detectionTumorVariationList.length,
    props.detectionRawDataVariationList.length,
    props.isACMGSF,
    props.report.result,
    props.affected_child_clinicalInformation,
    props.signature,
    props.signature2,
    props.signature3,
    props.signature4
  ])

  const readStaticFile = async () => {
    try {
      // 假设文件放在 public/files/example.txt

      if (props.template === '21') {
        const response =
          props.report.result === 'negative'
            ? await fetch('/云南全外报告模板2025 阴性位点模板.docx')
            : await fetch('/云南全外报告模板2025 位点模板.docx')

        const blob = await response.blob()

        // 将 Blob 转换为 File 对象

        const fileObj = new File([blob], 'example.txt', {
          type: blob.type || 'text/plain',

          lastModified: Date.now()
        })

        setFiles([fileObj])
      } else if (props.template === '22') {
        const response = await fetch('/基诺莱报告模板.docx')

        const blob = await response.blob()

        // 将 Blob 转换为 File 对象

        const fileObj = new File([blob], 'example.txt', {
          type: blob.type || 'text/plain',

          lastModified: Date.now()
        })

        setFiles([fileObj])
      } else if (props.template === '23') {
        const response = await fetch('/普瑞基准WGS报告模板.docx')

        const blob = await response.blob()

        // 将 Blob 转换为 File 对象

        const fileObj = new File([blob], 'example.txt', {
          type: blob.type || 'text/plain',

          lastModified: Date.now()
        })

        setFiles([fileObj])
      } else if (props.template === '24') {
        const response =
          props.report.result === 'negative'
            ? await fetch('/特发性矮小71基因遗传检测阴性报告.docx')
            : await fetch('/特发性矮小71基因遗传检测报告.docx')

        const blob = await response.blob()

        // 将 Blob 转换为 File 对象

        const fileObj = new File([blob], 'example.txt', {
          type: blob.type || 'text/plain',

          lastModified: Date.now()
        })

        setFiles([fileObj])
      } else if (props.template === '25') {
        const response =
          props.report.result === 'negative'
            ? await fetch('/临床全外显子组基因检测阴性报告.docx')
            : await fetch('/临床全外显子组基因检测报告.docx')

        const blob = await response.blob()

        // 将 Blob 转换为 File 对象

        const fileObj = new File([blob], 'example.txt', {
          type: blob.type || 'text/plain',

          lastModified: Date.now()
        })

        setFiles([fileObj])
      } else if (props.template === '26') {
        const response =
          props.report.result === 'negative'
            ? await fetch('/全外显子组基因检测阴性报告.docx')
            : await fetch('/全外显子组基因检测报告.docx')

        const blob = await response.blob()

        // 将 Blob 转换为 File 对象

        const fileObj = new File([blob], 'example.txt', {
          type: blob.type || 'text/plain',

          lastModified: Date.now()
        })

        setFiles([fileObj])
      }
    } catch (error) {
      console.error('Error reading file:', error)
    }
  }

  const renderDocx = async (fileData: any) => {
    await setTimeout(() => {
      if (dom.current) {
        import('docx-preview').then(async (docx) => {
          await docx.renderAsync(
            fileData,
            dom.current as HTMLElement,
            undefined,
            {
              className: 'docx', //默认和文档样式类的类名/前缀
              inWrapper: true, //启用围绕文档内容呈现包装器
              ignoreWidth: false, //禁用页面的渲染宽度
              ignoreHeight: false, //禁用页面的渲染高度
              ignoreFonts: false, //禁用字体渲染
              breakPages: true, //在分页符上启用分页
              ignoreLastRenderedPageBreak: true, //在lastRenderedPageBreak元素上禁用分页
              experimental: false, //启用实验功能（制表符停止计算）
              trimXmlDeclaration: true, //如果为true，则在解析之前将从xml文档中删除xml声明
              useBase64URL: false, //如果为true，图像、字体等将转换为base 64 URL，否则使用URL.createObjectURL
              // showChanges: false, //启用文档更改的实验渲染（插入/删除）
              debug: false //启用额外的日志记录
            }
          )
        })
      }
    }, 0)

    setTimeout(() => {
      const temp = document.getElementsByTagName('article')[0] as any

      const html = temp?.serializeWithStyles()

      if (html) {
        const parseDom = new DOMParser().parseFromString(html, 'text/html')
        const dom = document.getElementById('dom') as HTMLElement

        //

        setHtml(deserialize(parseDom.body))

        // dom.style.textAlign = 'left'

        //
      }
    }, 500)
  }

  const base64ToArrayBuffer = (dataURL: string) => {
    const base64Regex = /data:image\/(png|jpg|svg|svg\+xml);base64,/
    if (!base64Regex.test(dataURL)) {
      return false
    }
    const stringBase64 = dataURL.replace(base64Regex, '')
    let binaryString
    if (typeof window !== 'undefined') {
      binaryString = window.atob(stringBase64)
    } else {
      binaryString = new Buffer(stringBase64, 'base64').toString('binary')
    }
    const len = binaryString.length
    const bytes = new Uint8Array(len)
    for (let i = 0; i < len; i++) {
      const ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    return bytes.buffer
  }

  React.useEffect(() => {
    if (files.length && data) {
      files.map(async (file) => {
        const arrayBuffer = await file.arrayBuffer()
        const imageOpts = {
          getImage: (tagValue: any) => {
            // 处理图片数据（支持base64、URL、文件路径）

            const data = base64ToArrayBuffer(tagValue)

            //
            return data
          },
          getSize: (img: any) => {
            //

            return [63, 43]
          } // 固定尺寸 [宽度, 高度]
        }

        const imageModule = new ImageModule(imageOpts)
        const zip = new Pizzip(arrayBuffer)
        const doc = new Docxtemplater()

        doc.attachModule(imageModule)

        doc.loadZip(zip)

        // 加载替换内容
        doc.setData(data)

        doc.render()

        const out = doc.getZip().generate({
          type: 'blob',
          mimeType:
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        })

        const url = URL.createObjectURL(out)

        setUrl(url)
        console.log(url)

        setOut(out)

        setOpenNewReport(true)

        // FileSaver.saveAs(out, 'generated.docx')
      })
    }
  }, [files, data])

  const uploadOSSFIle = useMutation({
    mutationFn: async (params: {
      file: FormData
      config: AxiosRequestConfig
    }) =>
      await UploadOSSFIle({
        file: params.file,
        config: params.config
      }),

    onSuccess: (data) => {
      //
    }
  })

  const exportWord = (name: string) => {
    if (out) FileSaver.saveAs(out, `${name}`)
  }

  React.useEffect(() => {
    if (out) {
      // 1. 构建 FormData 并上传
      const formData = new FormData()

      // 'file' 字段名需与后端接收字段一致
      // out 是 Blob，可以直接 append，也可以转为 File 对象以指定文件名
      const file = new File(
        [out],
        `${props.report.name}-${props.report.id}.docx`,
        { type: out.type }
      )
      formData.append('file', file)

      formData.append('fileName', file.name)

      const path = `/${
        props.report.objectType === 'sample' ? 'samples' : 'analysis'
      }/${props.report.objectId}`

      formData.append('directory', path)
      uploadOSSFIle.mutateAsync({
        file: formData,
        config: {
          onUploadProgress: (progressEvent: any) => {
            const progress = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            )
          }
        }
      })
    }
  }, [out])

  React.useEffect(() => {
    if (out && openNewReport) {
      renderDocx(out)
    }
  }, [out, openNewReport])

  React.useImperativeHandle(ref, () => {
    return { exportWord }
  })

  return (
    <DropzoneWrapper>
      <Card>
        {out && openNewReport ? (
          <React.Fragment>
            <Box
              ref={dom}
              id="dom"
              sx={{
                tr: {
                  textAlign: 'left !important'
                },
                span: {
                  wordBreak: 'break-word'
                }
              }}
            ></Box>

            {/* <PasteHtmlExample
              value2=""
              value3=""
              value={html}
              value1={''}
              checked1={false}
            /> */}
          </React.Fragment>
        ) : (
          ''
        )}
      </Card>
    </DropzoneWrapper>
  )
})

export default WordReport
